export const FILTER_BY_OPTIONS = [
  { value: '', label: 'Filter By', field: 'state', allLabel: 'All Areas' },
  { value: 'state', label: 'State', field: 'state', allLabel: 'All States' },
  { value: 'depot', label: 'Depot', field: 'depot', allLabel: 'All Depots' },
  { value: 'area', label: 'Area', field: 'area', allLabel: 'All Areas' },
  { value: 'qtr', label: 'Qtr No', field: 'qtr', allLabel: 'All Qtr No' },
];

export function getActiveFilterMeta(filterByField) {
  return FILTER_BY_OPTIONS.find((f) => f.value === filterByField) ?? FILTER_BY_OPTIONS[0];
}

export function getFilterByDropdownOptions() {
  return FILTER_BY_OPTIONS.filter((f) => f.value !== '').map((f) => ({
    value: f.value,
    label: f.label,
  }));
}

export function getLocationOptionsFromRows(rows, field) {
  return [
    ...new Set(
      (rows ?? [])
        .map((r) => r[field])
        .filter((d) => d && d !== '—'),
    ),
  ].sort();
}

export function applyHierarchyFilters(rows, filterByField, locationFilter) {
  if (!locationFilter || !filterByField) return rows ?? [];
  const meta = getActiveFilterMeta(filterByField);
  return (rows ?? []).filter((row) => {
    const value = row[meta.field];
    if (value == null || value === '' || value === '—') return true;
    return value === locationFilter;
  });
}
